import { FACTURA } from '../actions/types';

const normalize = (val) => {
  if (val === null || val === undefined) return '';
  return (val + '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
};

const getListadoFromPayload = (payload) => {
  // Como todavía no tenemos contrato de respuesta, lo hacemos tolerante:
  if (Array.isArray(payload)) return payload;

  return (
    payload?.listado ||
    payload?.facturas ||
    payload?.data ||
    payload?.docs ||
    []
  );
};

const initialState = {
  listado: [],
  filtrado: [],

  filtros: {
    id_proveedor: '',
    fecha_inicio: '',
    fecha_fin: '',
  },
  filtro_activo: false,
  creado: null,
  error: null,
  categorias: [],
  subcategorias: [],
  productos_catalogo: [],
  subcategorias_nuevo_producto: [],
  codigo_producto: '',
  detalle_devolucion: null,
  loading: false
};

export default function facturasReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case FACTURA.BUSCAR: {
      const listado = getListadoFromPayload(payload);
      return {
        ...state,
        listado,
        filtrado: listado,
        error: null,
      };
    }

    case FACTURA.FILTRAR: {
      const texto = normalize(payload);
      if (!texto) {
        return { ...state, filtrado: state.listado };
      }

      const filtrado = state.listado.filter((f) => {
        const folio = normalize(f?.folio || f?.numero || f?.folio_factura || f?._id);
        const proveedor = normalize(
          f?.proveedor?.nombre ||
          f?.proveedor?.razon_social ||
          f?.proveedor_nombre ||
          f?.id_proveedor?.nombre
        );
        const estado = normalize(f?.estado?.nombre || f?.estado || f?.status);
        const fecha = normalize(f?.fecha || f?.fecha_factura || f?.createdAt);

        return (
          folio.includes(texto) ||
          proveedor.includes(texto) ||
          estado.includes(texto) ||
          fecha.includes(texto)
        );
      });

      return { ...state, filtrado };
    }

    case FACTURA.SET_FILTROS:
      return {
        ...state,
        filtros: {
          id_proveedor: payload?.id_proveedor || '',
          fecha_inicio: payload?.fecha_inicio || '',
          fecha_fin: payload?.fecha_fin || '',
        },
        filtro_activo: true,
      };

    case FACTURA.LIMPIAR_FILTROS:
      return {
        ...state,
        filtros: { ...initialState.filtros },
        filtro_activo: false,
      };

    case FACTURA.LIMPIAR:
      return { ...initialState };

    case FACTURA.ERROR:
      return { ...state, error: payload };
      
    case FACTURA.CREAR:
      return { ...state, creado: payload, error: null };

    case FACTURA.CREAR_ERROR:
      return { ...state, creado: null, error: payload };

    case FACTURA.EDITAR_ERROR:
      return {
        ...state,
        error: payload || { msg: 'Error' },
      };
      case FACTURA.DETALLE:
      return {
        ...state,
        detalle: payload?.factura || null,
        error: null,
      };

    case FACTURA.LIMPIAR_DETALLE:
      return {
        ...state,
        detalle: null,
      };
    
    case FACTURA.CATEGORIAS_CARGADAS:
        return {
            ...state,
            categorias: action.payload
        };

    case FACTURA.SUBCATEGORIAS_CARGADAS:
        return {
            ...state,
            subcategorias: action.payload
        };

    case FACTURA.PRODUCTOS_CARGADOS:
        return {
            ...state,
            productos_catalogo: action.payload
        };

    case FACTURA.SUBCATEGORIAS_NUEVO_PRODUCTO_CARGADAS:
        return {
            ...state,
            subcategorias_nuevo_producto: action.payload
        };

    case FACTURA.PRODUCTO_CREADO: {
        const prod = action.payload;
        const prev = Array.isArray(state.productos_catalogo) ? state.productos_catalogo : [];
        const existe = prev.some((p) => String(p?._id) === String(prod?._id));

        return {
            ...state,
            productos_catalogo: existe ? prev.map((p) => (String(p?._id) === String(prod?._id) ? prod : p)) : [prod, ...prev]
        };
    }

    case FACTURA.CODIGO_PRODUCTO_CARGADO:
      return {
          ...state,
          codigo_producto: payload || ''
      };

    case FACTURA.LIMPIAR_CODIGO_PRODUCTO:
        return {
            ...state,
            codigo_producto: ''
        };

    case FACTURA.LIMPIAR_CATALOGOS:
        return {
            ...state,
            subcategorias: [],
            productos_catalogo: []
        };
    
    case FACTURA.ELIMINAR:
    case FACTURA.DEVOLVER: {
        const id = action?.payload?.id;
        const removeById = (arr) => Array.isArray(arr) ? arr.filter(x => (x?._id + '') !== (id + '')) : arr;

        return {
            ...state,
            listado: removeById(state.listado),
            filtrado: removeById(state.filtrado),
        };
    }
    case FACTURA.DETALLE_DEVOLUCION:
    return {
        ...state,
        detalle_devolucion: action.payload
    };
    
    case FACTURA.LIMPIAR_DETALLE_DEVOLUCION:
        return {
            ...state,
            detalle_devolucion: null
        };

    case FACTURA.DEVOLVER_PARCIAL:
        return {
            ...state,
            listado: (state.listado || []).map(f => {
                if ((f?._id + '') !== (action?.payload?.id + '')) return f;
                return {
                    ...f,
                    monto_real: action?.payload?.monto_real
                };
            }),
            filtrado: (state.filtrado || []).map(f => {
                if ((f?._id + '') !== (action?.payload?.id + '')) return f;
                return {
                    ...f,
                    monto_real: action?.payload?.monto_real
                };
            })
        };

    case FACTURA.DEVOLVER_PARCIAL_ERROR:
        return state;

    default:
      return state;
  }
}
